import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

const AltioraNavbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <img 
              src="https://customer-assets.emergentagent.com/job_landing-hub-396/artifacts/6qtmykc4_49f33f49-895b-4aa5-9fe3-65aa14ace4ce.jfif" 
              alt="Altiora Business Solutions"
              className="h-16 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="font-semibold text-gray-700 hover:text-teal-600 transition-colors">
              Home
            </Link>
            <Link to="/services" className="font-semibold text-gray-700 hover:text-teal-600 transition-colors">
              Services
            </Link>
            <Link to="/industries" className="font-semibold text-gray-700 hover:text-teal-600 transition-colors">
              Industries
            </Link>
            <Link to="/about" className="font-semibold text-gray-700 hover:text-teal-600 transition-colors">
              About
            </Link>
            <Link to="/contact">
              <Button className="bg-teal-600 hover:bg-teal-700 text-white font-semibold">
                Get Free Consultation
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <Button
            variant="ghost"
            className="md:hidden text-gray-700"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </Button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 space-y-4 border-t border-gray-200">
            <Link
              to="/"
              className="block font-semibold text-gray-700 hover:text-teal-600 transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Home
            </Link>
            <Link
              to="/services"
              className="block font-semibold text-gray-700 hover:text-teal-600 transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Services
            </Link>
            <Link
              to="/industries"
              className="block font-semibold text-gray-700 hover:text-teal-600 transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Industries
            </Link>
            <Link
              to="/about"
              className="block font-semibold text-gray-700 hover:text-teal-600 transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              About
            </Link>
            <Link
              to="/contact"
              onClick={() => setMobileMenuOpen(false)}
            >
              <Button className="w-full bg-teal-600 hover:bg-teal-700 text-white font-semibold">
                Get Free Consultation
              </Button>
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default AltioraNavbar;
